const OWN_DOMAINS = ['cuandoelriosuena.com', 'acueducto.com', 'acueducto.studio'];

export function isOwnDomain(url: string): boolean {
  return OWN_DOMAINS.some((domain) => url.includes(domain));
}

/**
 * Returns the right `target`/`rel` for an `<a>` or `<Link>` based on the URL.
 *
 * - Relative URLs (`/foo`, `/es/bar`) and absolute URLs to own domains
 *   (cuandoelriosuena.com / acueducto.com / acueducto.studio): same tab,
 *   no extra attrs. Cross-domain nav between our sites should feel like
 *   regular site nav, not a "leaving the site" flag, and the browser
 *   forwards the `Referer` so Analytics on the destination credits the
 *   source.
 * - Third parties: `target="_blank" rel="noopener noreferrer"` (privacy
 *   default + standard tab-nabbing protection).
 */
export function linkAttributes(url: string): { target?: string; rel?: string } {
  if (!url.startsWith('http')) return {};
  if (isOwnDomain(url)) return {};
  return { target: '_blank', rel: 'noopener noreferrer' };
}
